import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(private http: HttpClient,private userService: UserService) {}

  // Common GET method
  get<T>(url: string, options?: { [key: string]: any }): Observable<T> {
    return this.http.get<T>(url, { ...options, observe: 'body' }).pipe(
      catchError((error) => this.handleError(error))
    );
  }

  // Common POST method
  post<T>(url: string, body: any, options?: { [key: string]: any }): Observable<T> {
    return this.http.post<T>(url, body, { ...options, observe: 'body' }).pipe(
      catchError((error) => this.handleError(error))
    );
  }

  // Error handling
  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'An unknown error occurred!';
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Client-side error: ${error.error.message}`;
      this.userService.traceMsg(errorMessage);
    } else {
      // Server-side error
      errorMessage = `Server-side error: ${error.status} - ${error.message}`;
      this.userService.traceMsg(errorMessage);
    }
    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}
